import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import { useClient } from '@/hooks/use-client';
import { LoadingSpinner } from './LoadingSpinner';
import { Body } from './ui/Typography';

interface ClientInfoProps {
  useLoadingSpinner?: boolean;
}

const ClientInfo = ({ useLoadingSpinner = true }: ClientInfoProps) => {
  const { clientId } = useParams<{ clientId: string; }>();
  const { client, isLoadingClient, clientError } = useClient(clientId!);

  if (isLoadingClient) {
    return useLoadingSpinner ? <LoadingSpinner /> : <div />;
  }

  if (clientError) {
    return <Alert severity="error">Failed to fetch client info</Alert>;
  }

  if (!client) {
    return <Alert severity="warning">No client information available</Alert>;
  }

  return (
    <div className='flex flex-col gap-1 py-1'>
      <Body>{client.name}</Body>
    </div>
  );
};

export default ClientInfo;